<template>
  <b-container fluid :class="isMobile ? 'p-0 m-0' : ''">
    <div class="modal-dialog" :class="!showStopEditing ? 'modal-xl' : ''"
         :style="showStopEditing ? 'min-width: 100%' :  ''">
      <div class="modal-content">
        <header class="modal-header">
          <b-container fluid class=" p-0 m-0 ">
            <b-row>
              <b-col cols="12" sm="12" md="12" lg="9" xl="9">
                <h5 class="my-modal-title">{{ $tc('message.trip', 1) }}</h5>
              </b-col>
              <b-button :disabled="tripId === 'new' || tripType === 'PERIODIC'" class="b-c-blue mr-4" style="margin-left: auto"
                        v-if="session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('ASSOCIATION_OPERATOR_TRIP', 'CREATE')] === '1'"
                        id="add-association-trip-operator" @click="showAssociateOperatorModal()">
                {{ $tc('message.associate', 1) }} {{ $tc('message.operator', 1).toLowerCase() }}
              </b-button>
              <b-img v-if="tripType === 'PERIODIC'"
                     v-b-popover.hover="$tc('info.operatorAssociations', 1)" :title="$tc('message.info', 1)"
                     src="img/tasto_informazioni.svg"
                     class="my-icon">
              </b-img>
            </b-row>
          </b-container>
        </header>

        <div :class="isMobile ? 'modal-body p-1' : 'modal-body'">
          <b-container fluid>
            <ValidationObserver v-if="session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('TRIP', 'UPDATE')] === '1'" ref="mainForm" v-slot="{ invalid, pending }">
              {{ checkTripSave(invalid, pending, !itemChanged, showStopEditing) }}
              <b-row class="mb-2">
                <b-col cols="12" sm="12" md="6" lg="6" xl="5"
                       order="1" order-sm="1" order-md="1" order-lg="1">
                  <!-- Name -->
                  <ValidationProvider :rules="{ required: true, max: 30 }" :name="`${$tc('message.name', 1)} (*)`"
                                      v-slot="{ valid, errors }">
                    <b-form-group :label="`${$tc('message.name', 1)} (*)`">
                      <b-form-input id="name"
                                    type="text"
                                    v-model="input.nome"
                                    :disabled="!!showStopEditing"
                                    :state="lodash.first(errors) && itemChanged ? false : (valid ? (itemChanged ? true : null) : null)">
                      </b-form-input>

                      <b-form-invalid-feedback id="inputLiveFeedback">
                        {{ lodash.first(errors) }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col cols="12" sm="12" md="12" lg="6" xl="7"
                       order="2" order-sm="2" order-md="3" order-lg="2">
                  <!-- Description -->
                  <ValidationProvider :rules="{ max: 50 }"
                                      :name="`${$tc('message.description', 1)}`" v-slot="{ valid, errors }">
                    <b-form-group :label="`${$tc('message.description', 1)}`">
                      <b-form-input id="description"
                                    type="text"
                                    :disabled="!!showStopEditing"
                                    v-model="input.descrizione"
                                    :state="lodash.first(errors) && itemChanged ? false : (valid ? (itemChanged ? true : null) : null)">
                      </b-form-input>

                      <b-form-invalid-feedback id="inputLiveFeedback">
                        {{ lodash.first(errors) }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <b-row class=" mt-2">
                <b-col cols="12" sm="12" md="12" lg="5" xl="5"
                       order="2" order-sm="2" order-md="3" order-lg="2">
                  <!-- Line -->
                  <ValidationProvider :rules="{ required: true, max: 50 }"
                                      :name="`${$tc('message.line', 1)} (*)`" v-slot="{ valid, errors }">
                    <b-form-group :label="`${$tc('message.line', 1)} (*)`">
                      <b-form-input id="description"
                                    type="text"
                                    :disabled="!!showStopEditing"
                                    v-model="input.linea"
                                    :state="lodash.first(errors) && itemChanged ? false : (valid ? (itemChanged ? true : null) : null)">
                      </b-form-input>

                      <b-form-invalid-feedback id="inputLiveFeedback">
                        {{ lodash.first(errors) }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col cols="12" sm="12" md="12" lg="5" xl="5"
                       order="2" order-sm="2" order-md="3" order-lg="2">
                  <!-- Table -->
                  <ValidationProvider :rules="{ required: true, max: 50 }"
                                      :name="`${$tc('message.table', 1)} (*)`" v-slot="{ valid, errors }">
                    <b-form-group :label="`${$tc('message.table', 1)} (*)`">
                      <b-form-input id="description"
                                    type="text"
                                    :disabled="!!showStopEditing"
                                    v-model="input.tabella"
                                    :state="lodash.first(errors) && itemChanged ? false : (valid ? (itemChanged ? true : null) : null)">
                      </b-form-input>

                      <b-form-invalid-feedback id="inputLiveFeedback">
                        {{ lodash.first(errors) }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="3" xl="2" class="text-right"
                       order="3" order-sm="3" order-md="2" order-lg="3">
                  <b-form-group :label="$tc('message.tripStatus', 1)"
                                label-for="input-executed">
                    <switch-button v-model="input.attiva"
                                   :color="{checked: '#007A79', unchecked: '#dc3545'}"
                                   :sync="true"
                                   :width="150"
                                   :height="32"
                                   :disabled="!!showStopEditing"
                                   :font-size="15.5"
                                   :speed="500"
                                   :labels="true">
                      <template slot="checked">
                        {{ $tc('message.enabled', 0) }}
                      </template>

                      <template slot="unchecked">
                        {{ $tc('message.disabled', 0) }}
                      </template>
                    </switch-button>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col v-if="tripType==='SINGLE'"  class="mt-1" cols="12" sm="12" md="5" lg="5" xl="5" order="3" order-sm="3" order-md="2"
                       order-lg="3">
                  <!-- Date -->
                  <ValidationProvider :rules="{ required: true }" :name="`${$tc('message.date', 1)}`"
                                      v-slot="{ valid, errors }">
                    <b-form-group :label="`${$tc('message.date', 1)} (*)`">
                      <b-input-group>
                        <flat-pickr id="date-trip"
                                    ref="date"
                                    :disabled="!!showStopEditing"
                                    :class="getFlatPickrClass('date', valid, errors, itemChanged, true)"
                                    v-model="input.data"
                                    :config="dateConfig">
                        </flat-pickr>

                        <div class="input-group-append">
                          <b-button class="fas fa-trash"
                                    @click="input.data = null"
                                    :disabled="!input.data">
                          </b-button>
                        </div>

                        <b-form-invalid-feedback id="inputLiveFeedback">
                          {{ lodash.first(errors) }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col v-if="tripType==='PERIODIC'"  class="mt-1" cols="12" sm="12" md="5" lg="5" xl="5" order="3" order-sm="3" order-md="2"
                       order-lg="3">
                  <!-- dateStart -->
                  <ValidationProvider :rules="{ required: true }" :name="`${$tc('message.dateStart', 1)}`"
                                      v-slot="{ valid, errors }">
                    <b-form-group :label="`${$tc('message.dateStart', 1)} (*)`">
                      <b-input-group>
                        <flat-pickr id="start-date"
                                    ref="startDate"
                                    :disabled="!!showStopEditing || tripId !== 'new'"
                                    :class="getFlatPickrClass('startDate', valid, errors, itemChanged, true)"
                                    v-model="input.da"
                                    :config="dateConfig">
                        </flat-pickr>

                        <div class="input-group-append">
                          <b-button class="fas fa-trash"
                                    @click="input.da = null"
                                    :disabled="!input.da">
                          </b-button>
                        </div>

                        <b-form-invalid-feedback id="inputLiveFeedback">
                          {{ lodash.first(errors) }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col v-if="tripType==='PERIODIC'"  class="mt-1" cols="12" sm="12" md="5" lg="5" xl="5" order="3" order-sm="3" order-md="2"
                       order-lg="3">
                  <!-- dateEnd -->
                  <ValidationProvider :rules="{ required: true }" :name="`${$tc('message.dateEnd', 1)}`"
                                      v-slot="{ valid, errors }">
                    <b-form-group :label="`${$tc('message.dateEnd', 1)} (*)`">
                      <b-input-group>
                        <flat-pickr id="end-date"
                                    ref="dateEnd"
                                    :disabled="!!showStopEditing || tripId !== 'new'"
                                    :class="getFlatPickrClass('dateEnd', valid, errors, itemChanged, true)"
                                    v-model="input.a"
                                    :config="dateConfig">
                        </flat-pickr>

                        <div class="input-group-append">
                          <b-button class="fas fa-trash"
                                    @click="input.a = null"
                                    :disabled="!input.a">
                          </b-button>
                        </div>

                        <b-form-invalid-feedback id="inputLiveFeedback">
                          {{ lodash.first(errors) }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col v-if="tripType==='PERIODIC' "  class="mt-1" cols="12" sm="12" md="5" lg="5" xl="5" order="3" order-sm="3" order-md="2"
                       order-lg="3">
                  <!-- days -->
                  <b-row class="ml-2">
                  <b-form-group :label="`${$tc('message.monday', 1)}`" class="mr-2">
                      <b-form-checkbox
                          :checked="input !== null && input.maschera_giorni !== undefined && input.maschera_giorni.charAt(0) === '1'"
                          @change="input.maschera_giorni = setCharAt(input.maschera_giorni,0, '1')"
                          :disabled="tripId !== 'new'">
                      </b-form-checkbox>
                  </b-form-group>
                    <b-form-group :label="`${$tc('message.thursday', 1)}`" class="mr-2">
                      <b-form-checkbox
                          :checked="input !== null && input.maschera_giorni !== undefined && input.maschera_giorni.charAt(1) === '1'"
                          @change="input.maschera_giorni = setCharAt(input.maschera_giorni, 1, '1')"
                          :disabled="tripId !== 'new'">
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group :label="`${$tc('message.wednesday', 1)}`" class="mr-2">
                      <b-form-checkbox
                          :checked="input !== null && input.maschera_giorni !== undefined && input?.maschera_giorni.charAt(2) === '1'"
                          @change="input.maschera_giorni = setCharAt(input.maschera_giorni, 2, '1')"
                          :disabled="tripId !== 'new'">
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group :label="`${$tc('message.tuesday', 1)}`" class="mr-2">
                      <b-form-checkbox
                          :checked="input !== null && input.maschera_giorni !== undefined && input?.maschera_giorni.charAt(3) === '1'"
                          @change="input.maschera_giorni = setCharAt(input.maschera_giorni, 3, '1')"
                          :disabled="tripId !== 'new'">
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group :label="`${$tc('message.friday', 1)}`" class="mr-2">
                      <b-form-checkbox
                          :checked="input !== null && input.maschera_giorni !== undefined && input?.maschera_giorni.charAt(4) === '1'"
                          @change="input.maschera_giorni = setCharAt(input.maschera_giorni, 4, '1')"
                          :disabled="tripId !== 'new'">
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group :label="`${$tc('message.saturday', 1)}`" class="mr-2">
                      <b-form-checkbox
                          :checked="input !== null && input.maschera_giorni !== undefined && input?.maschera_giorni.charAt(5) === '1'"
                          @change="input.maschera_giorni = setCharAt(input.maschera_giorni, 5, '1')"
                          :disabled="tripId !== 'new'">
                      </b-form-checkbox>
                    </b-form-group>
                    </b-row>

              </b-col>
                <b-col cols="12" sm="12" md="5" lg="5" xl="5" order="3" order-sm="3" order-md="2" order-lg="3">
                  <ValidationProvider :rules="{ required: true }" :name="`${$tc('message.deposit', 1)}`">
                  <b-form-group :label="`${$tc('message.deposit', 1)} (*)`">
                    <v-select :options="depositOptions"
                              :disabled="!!showStopEditing"
                              :reduce="obj => obj.id"
                              label="nome"
                              placeholder="Seleziona"
                              v-model="input.id_deposito">
                    </v-select>
                  </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="12" md="5" lg="5" xl="5" order="3" order-sm="3" order-md="2" order-lg="3">
                  <!-- Vehicle -->
                  <ValidationProvider :rules="{ max: 50 }"
                                      :name="`${$tc('message.vehicle', 1)}`"
                                      v-slot="{ errors }">
                    <b-form-group :label="`${$tc('message.vehicle', 1)}`">
                      <b-form-input id="trip-stop-vehicle"
                                    type="text"
                                    :disabled="!!showStopEditing"
                                    v-model="input.vettura"
                                    :state="lodash.first(errors) ? false : null">
                      </b-form-input>

                      <b-form-invalid-feedback id="inputLiveFeedback">
                        {{ lodash.first(errors) }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col v-if="tripId !== 'new' && tripType === 'SINGLE'" cols="12" sm="12" md="5" lg="5" xl="5" order="3" order-sm="3" order-md="2" order-lg="3">
                  <!-- SpecialEquipment -->
                      <b-row class="ml-1">
                        {{$tc('message.specialEquipment', 1)}}
                        <b-img
                            v-b-popover.hover="`${$tc('info.specialEquipment', 1)}`" :title="`${$tc('message.info', 1)}`"
                            src="img/tasto_informazioni.svg"
                            class="my-icon-small">
                        </b-img>
                      </b-row>
                  <h4 class="ml-5">{{input.totale_dotazioni_speciali || 0}}</h4>

                </b-col>
              </b-row>
            </ValidationObserver>
            <ValidationObserver ref="stopForm" v-slot="{ invalid, pending }">
              <b-row v-if="tripId !== 'new'">
                <transition :name="squeezeStopList ? 'slide-right' : 'slide-left'" mode="out-in">
                  <b-col class="border mt-3"
                         cols="12" sm="12" md="12"
                         :lg="squeezeStopList ? '4' : '12'"
                         :xl="squeezeStopList ? '4' : '12'">
                    <b-container fluid class="m-0 p-0">
                      <b-row class="modal-header d-flex align-items-center">
                        <h5 class="my-modal-title d-inline-flex">{{ $tc('message.stop', 2) }}</h5>

                        <b-button class="b-c-blue float-right" id="add-trip-stop"
                                  v-if="session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('STOP', 'CREATE')] === '1'"
                                  @click="showStopEditingSide(null, 'edit')">
                          {{ $t('message.add') }}
                        </b-button>
                      </b-row>

                      <b-row>
                        <b-col class="p-2">
                          <b-list-group class="mt-3 mb-3">
                            <draggable v-model="tripStopOption"
                                       v-bind="{ animation: 350 }"
                                       :disabled="!enableDrag"
                                       @end="handleDragStop">
                              <transition-group id="trans-group" type="transition"
                                                :name="!isDragging ? 'flip-list' : null">
                                <b-list-group-item v-for="(element, index) in tripStopOption"
                                                   v-on:mouseover="enableDrag = true"
                                                   :id="'list-group-item-' + index"
                                                   :key="element.id" class="d-flex"
                                                   :class="isDragging && element.id === isDragging ? 'b-c-l-gray' : element.class != null ? element.class : ''">
                                  <b-container class="px-1" id="list-container">
                                    <b-row align-h="center" id="stop-list">
                                      <b-col cols="auto" sm="6" md="8"
                                             :lg="squeezeStopList ? '5' : '10'"
                                             :xl="squeezeStopList ? '6' : '10'"
                                             class="mr-0 pl-0 pr-0 mr-auto">
                                        <div class="stop-details-row">
                                          <div class="stop-details-col">
                                            <b-badge class="b-c-green p-2">{{ updateTripStopIdx(element, index) }} {{element.orario_inizio}}
                                            </b-badge>
                                            <div class="stop-details-text"></div>

                                            <b-badge
                                                class="b-c-green d-flex mx-1 py-1"
                                                v-if="element.fermata.struttura && isMobile"
                                                v-b-popover.hover.top="element.struttura">
                                              <i class="fas fa-building p-2 fa-lg"/>
                                            </b-badge>
                                            <div class="stop-details-text"
                                                 v-if="isMobile">

                                            </div>

                                            <h6 v-if="element.fermata.nome" class="stop-details-text">
                                              {{ element.fermata.nome }},
                                            </h6>

                                            <div class="stop-details-text" v-if="!isMobile">
                                              <b-badge class="b-c-green d-flex mx-1 py-1"
                                                       v-if="element.fermata.struttura"
                                                       v-b-popover.hover.top="element.fermata.struttura">
                                                <i class="fas fa-building p-2 fa-lg"/>
                                              </b-badge>
                                            </div>

                                            <h6 class="stop-details-text" v-if="!isMobile">
                                              {{ element.fermata.struttura ? `${element.fermata.struttura},` : '' }}
                                            </h6>

                                            <h6 class="stop-details-text">
                                              {{ element.fermata.indirizzo ? `${element.fermata.indirizzo}` : '' }}
                                              {{ element.fermata.civico ? `, ${element.fermata.civico}` : '' }}
                                            </h6>
                                          </div>
                                        </div>
                                      </b-col>

                                      <b-col cols="auto" class="m-0 p-0 ml-auto" id="stop-buttons">
                                        <b-button id="user-button"
                                                  class="d-inline-flex fas fa-user-alt align-self-end mr-2"
                                                  size="sm" @click="showStopEditingSide(element, 'association')">
                                        </b-button>

                                        <b-button id="edit-button"
                                                  class="d-inline-flex fas fa-pencil-alt align-self-end mr-2"
                                                  v-if="session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('STOP', 'UPDATE')] === '1'"
                                                  size="sm" @click="showStopEditingSide(element, 'edit')">
                                        </b-button>
                                        <b-button id="info-button"
                                                  class="d-inline-flex fas fa-eye align-self-end mr-2"
                                                  v-else
                                                  size="sm" @click="openInfoModal(element)">
                                        </b-button>

                                        <b-button id="delete-stop-button"
                                                  v-if="session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('STOP', 'DELETE')] === '1'"
                                                  class="d-inline-flex fas fa-trash-alt align-self-end"
                                                  size="sm" @click="showStopEditingSide(element)">
                                        </b-button>
                                      </b-col>
                                    </b-row>
                                  </b-container>
                                </b-list-group-item>
                              </transition-group>
                            </draggable>
                          </b-list-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </transition>

                <b-col id="select-children"
                       :class="!!showStopEditing ? `border mt-3 ${isMobile ? '' : ' border-left-0'}` : ''"
                       cols="12" sm="12" md="12" lg="8" xl="8">
                  <transition :name="!showStopEditing ? 'slide-right' : 'slide-left'" mode="out-in"
                              v-on:before-enter="squeezeStopList = true"
                              v-on:after-leave="squeezeStopList = false">
                    <b-container id="trip-stop-modal" fluid class="m-0 p-0" v-show="!!showStopEditing">
                      <b-row v-if="showStopEditing === 'edit'">
                        <b-col>
                          <b-container fluid class="m-0 p-0">
                            <b-row align-v="center" class="modal-header border-bottom-0">
                              <h5 class="my-modal-title">
                                {{ stopData.id ? $tc('message.edit', 1) : $tc('message.add', 1) }}
                                {{ $tc('message.stop', 1) }}</h5>

                              <b-button id="header-cancel-button-stop"
                                        type="button"
                                        class="float-right"
                                        @click="hideStopEditingSide()">
                                {{ $tc('message.close', 1) }} {{ $tc('message.stop', 1) }}
                              </b-button>
                            </b-row>

                            <b-row class="my-border-top mt-0"/>

                            <b-row>
                              <b-col cols="12" sm="12" md="12" lg="4" xl="4">
                                <!-- Name -->
                                <ValidationProvider ref="name-validator" :rules="{ max: 50 }"
                                                    :name="`${$tc('message.name', 1)}`" v-slot="{ valid, errors }">
                                  <b-form-group :label="`${$tc('message.name', 1)}`">
                                    <v-select :options="getEditStopOptions(stopOption, 'nome')"
                                              :maxHeight="'100px'"
                                              ref="name"
                                              id="trip-stop-name"
                                              taggable
                                              :reduce="obj => obj.nome || obj"
                                              label="nome"
                                              :class="checkSelectStyle('name', stopChanged, valid, errors, true, stop.nome, 30)"
                                              v-model="stop.nome">
                                    </v-select>

                                    <div v-if="errors.length !== 0" class="my-invalid-feedback">
                                      {{ lodash.first(errors) }}
                                    </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>

                              <b-col cols="12" sm="12" md="12" lg="4" xl="4">
                                <!-- Structure -->
                                <ValidationProvider ref="name-validator" :rules="{ max: 50 }"
                                                    :name="`${$tc('message.structure', 1)}`" v-slot="{ valid, errors }">
                                  <b-form-group :label="`${$tc('message.structure', 1)}`">
                                    <v-select :options="getEditStopOptions(stopOption, 'struttura')"
                                              :maxHeight="'100px'"
                                              ref="structure"
                                              id="trip-stop-structure"
                                              taggable
                                              :reduce="obj => obj.struttura || obj"
                                              label="struttura"
                                              :class="checkSelectStyle('structure', stopChanged, valid, errors, true, stop.struttura, 30)"
                                              v-model="stop.struttura">
                                    </v-select>

                                    <div v-if="errors.length !== 0" class="my-invalid-feedback">
                                      {{ lodash.first(errors) }}
                                    </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>

                              <b-col cols="12" sm="12" md="12" lg="4" xl="4">
                                <!-- Address -->
                                <ValidationProvider ref="address-validator"
                                                    :rules="{ required: true, max: 50 }"
                                                    :name="`${$tc('message.address', 1)}`" v-slot="{ valid, errors }">
                                  <b-form-group :label="`${$tc('message.address', 1)} (*)`">
                                    <v-select :options="getEditStopOptions(stopOption, 'indirizzo')"
                                              ref="address"
                                              id="trip-stop-address"
                                              taggable
                                              label="indirizzo"
                                              :reduce="obj => obj.indirizzo || obj"
                                              :class="checkSelectStyle('address', stopChanged, valid, errors, true, stop.indirizzo, 50)"
                                              v-model="stop.indirizzo">
                                    </v-select>

                                    <div v-if="errors.length !== 0" class="my-invalid-feedback">
                                      {{ lodash.first(errors) }}
                                    </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>

                              <b-col cols="12" sm="12" md="12" lg="4" xl="4">
                                <!-- Civic number -->
                                <ValidationProvider ref="civic-validator" :name="`${$tc('message.civicNumber', 1)}`"
                                                    :rules="{ max: 20 }" v-slot="{ valid, errors }">
                                  <b-form-group :label="`${$tc('message.civicNumber', 1)}`">
                                    <v-select :options="getEditStopOptions(stopOption, 'civico')"
                                              ref="civic"
                                              id="trip-stop-civic"
                                              taggable
                                              label="civico"
                                              :reduce="obj => obj.civico || obj"
                                              :class="checkSelectStyle('civic', stopChanged, valid, errors, true, stop.civico, 8)"
                                              v-model="stop.civico">
                                    </v-select>

                                    <div v-if="errors.length !== 0" class="my-invalid-feedback">
                                      {{ lodash.first(errors) }}
                                    </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>

                              <b-col cols="12" sm="12" md="12" lg="8" xl="8">
                                <!-- Description -->
                                <ValidationProvider :rules="{ max: 50 }"
                                                    :name="`${$tc('message.description', 1)}`"
                                                    v-slot="{ errors }">
                                  <b-form-group :label="`${$tc('message.description', 1)}`">
                                    <b-form-input id="trip-stop-description"
                                                  type="text"
                                                  v-model="stop.descrizione"
                                                  :state="lodash.first(errors) ? false : null">
                                    </b-form-input>

                                    <b-form-invalid-feedback id="inputLiveFeedback">
                                      {{ lodash.first(errors) }}
                                    </b-form-invalid-feedback>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>

                              <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                                <ValidationProvider ref="time-validator" :name="`${$tc('message.startTime', 1)}`"
                                                    :rules="{ required: true}" v-slot="{ valid, errors }">
                                  <b-form-group :label="`${$tc('message.startTime', 1)} (*)`"
                                                label-for="input-infringement-time">
                                    <b-input-group>
                                      <flat-pickr id="input-infringement-time"
                                                  :class="getFlatPickrClass('startTime', valid, errors, stopChanged, true)"
                                                  v-model="stopData.orario_inizio"
                                                  @input="stopChanged = stopData.orario_inizio != null"
                                                  :config="timePicker"
                                      >
                                      </flat-pickr>
                                      <div class="input-group-append">
                                        <b-button class="fas fa-trash"
                                                  @click="stopData.orario_inizio = null"
                                                  :disabled="!stopData.orario_inizio">
                                        </b-button>
                                      </div>
                                    </b-input-group>
                                    <div v-if="errors.length !== 0" class="my-invalid-feedback">
                                      {{ lodash.first(errors) }}
                                    </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>

                              <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                                <ValidationProvider ref="time-validator" :name="`${$tc('message.endTime', 1)}`" :rules="{timeMax: stopData.orario_fine != null ? [stopData.orario_inizio,stopData.orario_fine] : []}"
                                                    v-slot="{ valid, errors }">
                                  <b-form-group :label="`${$tc('message.endTime', 1)}`"
                                                label-for="input-end-time">
                                    <b-input-group>
                                      <flat-pickr id="input-end-time"
                                                  :class="getFlatPickrClass('endTime', valid, errors, stopChanged, false)"
                                                  v-model="stopData.orario_fine"
                                                  @input="stopChanged = true"
                                                  :config="timePicker"
                                      >
                                      </flat-pickr>
                                      <div class="input-group-append">
                                        <b-button class="fas fa-trash"
                                                  @click="stopData.orario_fine = null"
                                                  :disabled="!stopData.orario_fine">
                                        </b-button>
                                      </div>
                                    </b-input-group>
                                    <div v-if="errors.length !== 0" class="my-invalid-feedback">
                                      {{ lodash.first(errors) }}
                                    </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-col>
                      </b-row>

                      <b-row v-if="showStopEditing === 'association'">
                        <b-col>
                          <b-container fluid class="m-0 p-0 mt-3">
                            <b-tabs v-model="tabIndex">
                              <b-tab @click="statusFilter = null" :title="`${$tc('message.child', 2)}`" active>
                                <standard-table v-if="tabIndex===0"
                                                ref="childrenlist"
                                                id="children-list"
                                                :noContainerPadding="true"
                                                :fullWidth="true"
                                                :items="getChildrenForTable(structureFilter, statusFilter)"
                                                :fields="getChildFields()"
                                                :customFields="getCustomFields('CHILDREN')"
                                                :theadTrClass="'first-2-table-cols'"
                                                :disableAutoUnSelection="true"
                                                :noPaginationMargin="true"
                                                @rowSelected="handleTableSelection"
                                                @allSelected="handleAllSelected"
                                                :disable-all-checkboxes="session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('STOP', 'UPDATE')] !== '1'"
                                                :row-before-search="{cols: 12,sm: 12,md: 12,lg: 12,xl: 12,order: 1,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                                                :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                                                :row-after-search="{cols: 12, sm: 12, md: 12, lg: 12, xl: 6, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                                                :row-pagination="{cols: 12, sm: 12, md: 12, lg: 6, xl: 6}"
                                                :row-between-pagination="{cols: 12, sm: 4, md: 6, lg: 1, xl: 3}"
                                                :row-per-page="{cols: 12, sm: 8, md: 6, lg: 5, xl: 3}">
                                  <b-container slot="row-after-search" class="mw-100 p-0">
                                    <b-row>
                                      <b-col cols="auto">
                                        <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                                          {{ $t('message.resetFilters') }}
                                        </b-button>
                                      </b-col>

                                      <b-col cols="auto" class="mb-3">
                                        <b-button @click="showCollapse = !showCollapse"
                                                  :class="showCollapse ? 'b-c-red' : 'b-c-green'" id="show-filters">
                                      <span v-show="!showCollapse"
                                            class="when-opened">{{
                                          $t('message.show')
                                        }} {{ $tc('message.filter', 2).toLowerCase() }}</span>
                                          <span v-show="showCollapse"
                                                class="when-closed">{{
                                              $t('message.hide')
                                            }} {{ $tc('message.filter', 2).toLowerCase() }}</span>
                                        </b-button>
                                      </b-col>
                                    </b-row>
                                  </b-container>

                                  <b-container slot="after-search" class="mw-100 p-0"
                                  >
                                    <b-row v-if="session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('STOP', 'UPDATE')] === '1'">
                                      <b-col cols="12" sm="12" md="12" lg="4" xl="4">
                                        <!-- Status -->
                                        <b-form-group
                                            :label="`${$tc('message.selectLabel', 1)} ${$tc('message.status', 1).toLowerCase()} per i selezionati`">
                                          <v-select :options="statusOptions"
                                                    :reduce="obj => obj.value"
                                                    label="text"
                                                    placeholder="Seleziona"
                                                    v-model="statusFilter">
                                          </v-select>
                                        </b-form-group>
                                      </b-col>
                                    </b-row>
                                    <b-collapse id="my-collapse" v-model="showCollapse">
                                      <b-container class="mw-100 m-0 p-0">
                                        <b-row>
                                          <b-col cols="12" sm="12" md="12" lg="6" xl="6">
                                            <!-- Structure -->
                                            <b-form-group :label="`${$tc('message.structure', 1)}`">
                                              <v-select :options="structureOptions"
                                                        :reduce="obj => obj.id"
                                                        label="den_sintetica"
                                                        v-model="structureFilter">
                                              </v-select>
                                            </b-form-group>
                                          </b-col>
                                          <b-col cols="12" sm="12" md="12" lg="6" xl="6">
                                            <!-- Attributes -->
                                            <b-form-group :label="`${$tc('message.attribute', 2)}`">
                                              <v-select :options="attributeOptions"
                                                        :reduce="obj => obj.id"
                                                        label="nome"
                                                        placeholder="Seleziona"
                                                        v-model="attributeFilter">
                                              </v-select>
                                            </b-form-group>
                                          </b-col>
                                        </b-row>
                                      </b-container>
                                    </b-collapse>
                                  </b-container>

                                  <slot slot="up&down" slot-scope="row">
                                    <transition name="fade" :duration="{ enter: 330, leave: 1 }">
                                      <i class="fas fa-ban fa-lg c-ls-gray hover-not-allowed"
                                         v-if="!row.item.selected"/>
                                    </transition>

                                    <transition name="fade"
                                                :duration="{ enter: 330, leave: 1 }">
                                      <i class="fas fa-arrow-up fa-lg c-green hover-enabled"
                                         @click="handleUpAndDown(row.item, false)"
                                         v-b-popover.hover.right="$tc('message.up', 1)"
                                         v-if="row.item.salita && row.item.selected">
                                      </i>
                                    </transition>

                                    <transition name="fade" :duration="{ enter: 330, leave: 1 }">
                                      <i class="fas fa-arrow-down fa-lg c-red hover-enabled"
                                         @click="handleUpAndDown(row.item, true)"
                                         v-b-popover.hover.right="$tc('message.down', 1)"
                                         v-if="!row.item.salita && row.item.selected"/>
                                    </transition>

                                    {{
                                      isMobile ? (row.item.selected ? (row.item.salita ? $tc('message.up', 1) : $tc('message.down', 1)) : '') : ''
                                    }}
                                  </slot>
                                  <slot slot="note" slot-scope="row">
                                    <ValidationProvider ref="note-validator" :name="`${$tc('message.note', 2)}`" :rules="{max: 50}"
                                                        v-slot="{ errors }">
                                    <b-form-textarea
                                        v-if="row.item.selected"
                                        rows="2"
                                        max-rows="6"
                                        id="notes"
                                        type="text"
                                        v-model="row.item.note"
                                        :state="lodash.first(errors) ? false : null">
                                    </b-form-textarea>
                                      <b-form-invalid-feedback id="inputLiveFeedback">
                                        {{ lodash.first(errors) }}
                                      </b-form-invalid-feedback>
                                    </ValidationProvider>
                                  </slot>
                                </standard-table>
                              </b-tab>
                              <b-tab @click="statusFilter = null" :title="`${$tc('message.operator', 2)}`">
                                <standard-table
                                    ref="operatorslist"
                                    id="operators-list"
                                    :noContainerPadding="true"
                                    :fullWidth="true"
                                    :items="getOperatorsForTable(statusFilter)"
                                    :fields="getOperatorFields()"
                                    :customFields="getCustomFields()"
                                    :theadTrClass="'first-2-table-cols'"
                                    :disableAutoUnSelection="true"
                                    :noPaginationMargin="true"
                                    @rowSelected="handleTableSelection"
                                    @allSelected="handleAllSelected"
                                    :disable-all-checkboxes="session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('STOP', 'UPDATE')] !== '1'"

                                    :row-before-search="{cols: 12,sm: 12,md: 12,lg: 12,xl: 12,order: 1,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                                    :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                                    :row-after-search="{cols: 12, sm: 12, md: 12, lg: 12, xl: 6, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                                    :row-pagination="{cols: 12, sm: 12, md: 12, lg: 6, xl: 6}"
                                    :row-between-pagination="{cols: 12, sm: 4, md: 6, lg: 1, xl: 3}"
                                    :row-per-page="{cols: 12, sm: 8, md: 6, lg: 5, xl: 3}">

                                  <b-container slot="after-search" class="mw-100 p-0">
                                    <b-row v-if="session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('STOP', 'UPDATE')] === '1'">
                                      <b-col cols="12" sm="12" md="12" lg="4" xl="4">
                                        <!-- Status -->
                                        <b-form-group
                                            :label="`${$tc('message.selectLabel', 1)} ${$tc('message.status', 1).toLowerCase()} per i selezionati`">
                                          <v-select :options="statusOptions"
                                                    :reduce="obj => obj.value"
                                                    label="text"
                                                    placeholder="Seleziona"
                                                    v-model="statusFilter">
                                          </v-select>
                                        </b-form-group>
                                      </b-col>
                                    </b-row>
                                  </b-container>
                                  <slot slot="id_assistente" slot-scope="row">
                                    <h6 class="text-center">{{row.item.id_letterale}}</h6>
                                  </slot>
                                  <slot slot="up&down" slot-scope="row">
                                    <transition name="fade" :duration="{ enter: 330, leave: 1 }">
                                      <i class="fas fa-ban fa-lg c-ls-gray hover-not-allowed"
                                         v-if="!row.item.selected"/>
                                    </transition>

                                    <transition name="fade"
                                                :duration="{ enter: 330, leave: 1 }">
                                      <i class="fas fa-arrow-up fa-lg c-green hover-enabled"
                                         @click="handleUpAndDown(row.item, false)"
                                         v-b-popover.hover.right="$tc('message.up', 1)"
                                         v-if="row.item.salita && row.item.selected">
                                      </i>
                                    </transition>

                                    <transition name="fade" :duration="{ enter: 330, leave: 1 }">
                                      <i class="fas fa-arrow-down fa-lg c-red hover-enabled"
                                         @click="handleUpAndDown(row.item, true)"
                                         v-b-popover.hover.right="$tc('message.down', 1)"
                                         v-if="!row.item.salita && row.item.selected"/>
                                    </transition>

                                    {{
                                      isMobile ? (row.item.selected ? (row.item.salita ? $tc('message.up', 1) : $tc('message.down', 1)) : '') : ''
                                    }}
                                  </slot>
                                </standard-table>
                              </b-tab>
                            </b-tabs>

                          </b-container>
                        </b-col>
                      </b-row>

                      <b-row class="my-border-top mb-3">
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                          <b-container fluid class=" m-0 p-0">
                            <b-row align-h="end">
                              <b-col cols="12" sm="12" md="12" lg="auto" xl="auto">
                                <b-button id="save-stop"
                                          type="button"
                                          class="float-right ml-3 mt-2 b-c-green"
                                          :disabled="invalid || pending || !stopChanged"
                                          v-if="(session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('STOP', 'CREATE')] === '1' && showStopEditing === 'edit')
                                          || session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('STOP', 'UPDATE')] === '1'"
                                          @click="saveStop()">
                                  {{ $tc('message.save', 1) }} {{ $tc('message.stop', 1) }}
                                </b-button>
                              </b-col>

                              <b-col cols="12" sm="12" md="12" lg="auto" xl="auto">
                                <b-button id="footer-cancel-button-stop"
                                          type="button"
                                          class="float-right ml-3 mt-2"
                                          @click="hideStopEditingSide()">
                                  {{ $tc('message.close', 1) }} {{ $tc('message.stop', 1) }}
                                </b-button>
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-col>
                      </b-row>
                    </b-container>
                  </transition>
                </b-col>
              </b-row>
            </ValidationObserver>

            <transition :name="showStopEditing ? 'fade-down' : 'fade-up'" mode="out-in">
              <b-row v-show="!showStopEditing">
                <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <b-container fluid class="m-0 p-0 mt-2">
                    <b-row align-h="end">
                      <b-col cols="12" sm="12" md="12" lg="auto" xl="auto">
                        <b-button id="save" v-if="session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('TRIP', 'UPDATE')] === '1'"
                                  type="button"
                                  class="float-right b-c-green"
                                  :disabled="!!enableTripSaveButtons"
                                  @click="save(false)"> {{ $tc('message.save', 1) }}
                        </b-button>
                      </b-col>

                      <b-col cols="12" sm="12" md="12" lg="auto" xl="auto">
                        <b-button id="save-and-exit"  v-if="session && session.utente && session.utente.auth_mask && session.utente.auth_mask[maskValue('TRIP', 'UPDATE')] === '1'"
                                  type="button"
                                  class="float-right b-c-green"
                                  :disabled="!!enableTripSaveButtons"
                                  @click="save(true)"> {{ $tc('message.saveClose', 1) }}
                        </b-button>
                      </b-col>

                      <b-col cols="12" sm="12" md="12" lg="auto" xl="auto">
                        <b-button id="cancel-button"
                                  type="button"
                                  class="float-right"
                                  @click="exitCheck(itemChanged)"> {{ $tc('message.close', 1) }}
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-col>
              </b-row>
            </transition>
          </b-container>
        </div>
      </div>
    </div>
    <b-modal ref="infoModal" id="infoModal" :title="`${$tc('message.details', 1)}`" hide-footer>
      <b-container>
      <b-row>
        <b-col>
          <b-container fluid class="m-0 p-0">
            <b-row>
              <b-col cols="12">
                <!-- Name -->
                <div class="d-flex">
                  <h6><b>{{ $tc('message.name', 1) }}</b></h6>
                  <h6 class="ml-2">{{ stop.nome || $tc('message.emptyValue') }}</h6>
                </div>
              </b-col>

              <b-col cols="12">
                <!-- Structure -->
                <div class="d-flex">
                  <h6><b>{{ $tc('message.structure', 1) }}</b></h6>
                  <h6 class="ml-2">{{ stop.struttura || $tc('message.emptyValue') }}</h6>
                </div>
              </b-col>

              <b-col cols="12">
                <!-- Address -->
                <div class="d-flex">
                  <h6><b>{{ $tc('message.address', 1) }}</b></h6>
                  <h6 class="ml-2">{{ stop.indirizzo || $tc('message.emptyValue') }}</h6>
                </div>
              </b-col>

              <b-col cols="12">
                <!-- Civic number -->
                <div class="d-flex">
                  <h6><b>{{ $tc('message.civicNumber', 1) }}</b></h6>
                  <h6 class="ml-2">{{ stop.civico || $tc('message.emptyValue') }}</h6>
                </div>
              </b-col>

              <b-col cols="12">
                <!-- Description -->
                <div class="d-flex">
                  <h6><b>{{ $tc('message.description', 1) }}</b></h6>
                  <h6 class="ml-2">{{ stop.descrizione || $tc('message.emptyValue') }}</h6>
                </div>
              </b-col>

              <b-col cols="12">
                <div class="d-flex">
                  <h6><b>{{ $tc('message.startTime', 1) }}</b></h6>
                  <h6 class="ml-2">{{ stopData.orario_inizio || $tc('message.emptyValue') }}</h6>
                </div>
              </b-col>

              <b-col cols="12">
                <div class="d-flex">
                  <h6><b>{{ $tc('message.endTime', 1) }}</b></h6>
                  <h6 class="ml-2">{{ stopData.orario_fine || $tc('message.emptyValue') }}</h6>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
        <div slot="modal-footer" class="w-100 justify-content-end d-flex">
          <b-button class="b-c-green" @click="$refs.infoModal.hide()"> Ok</b-button>
        </div>
      </b-container>
    </b-modal>
    <b-modal ref="deleteModal" id="deleteModal" :title="`${$t('message.caution')}!`">
      <b-container fluid>
        <b-row>
          <h5>{{ $t('message.deleteCheck') }} "{{ stopData && stopData.fermata && stopData.fermata.nome }}"?</h5>
        </b-row>

        <b-row v-if="lodash.find(childOptions, obj => obj.selected)">
          <h6 class="c-red">{{ $tc('message.willBeRemoved', 1) }}</h6>
        </b-row>

        <b-row v-for="item in childOptions" :key="item.id">
          <h6 v-if="item.selected">- {{ item.cognome }} {{ item.nome }}, {{ $tc('message.structure', 1) }}:
            {{ item.struttura }} </h6>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-delete-close" class="m-1 b-c-green" @click="hideDeleteModal()">{{ $t('message.cancel') }}
        </b-button>

        <b-button id="nw-delete-continue" class="m-1 b-c-green" @click="deleteItem()">{{ $t('message.continue') }}
        </b-button>
      </div>
    </b-modal>
    <b-modal ref="warningDeleteModal" id="warningDeleteModal" :title="`${$t('message.caution')}!`">
      <b-container fluid>
        <b-row>
          <h5>{{ $t('message.deleteWarning') }} </h5>
        </b-row>
      </b-container>
      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-delete-continue" class="m-1 b-c-green" @click="$refs.warningDeleteModal.hide()">
          {{ $t('message.continue') }}
        </b-button>
      </div>
    </b-modal>
    <b-modal ref="associateOperatorsModal" id="associateOperatorsModal"
             :title="`${$tc('message.associate', 1) } ${$tc('message.operator', 1).toLowerCase()}`" size="lg"
             no-close-on-backdrop no-close-on-esc hide-header-close
             @hide="checkAssociateModalClosing">
      <standard-table ref="associateOperatorsModal"
                      id="associateOperatorsModal"
                      :noContainerPadding="true"
                      :fullWidth="true"
                      :theadTrClass="'first-table-cols'"
                      :items="associatedAssistants"
                      :fields="getFields()"
                      :disableAutoUnSelection="true"

                      :before-search="{cols: 12,sm: 12,md: 12,lg: 12,xl: 12}"

                      :row-search="{cols: 12,sm: 12,md: 12,lg: 6,xl: 6}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 6, xl: 6}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 4, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 3}"
                      @rowSelected="handleAssociationAssistantOperatorRowSelected"
                      @allSelected="handleAssociationAssistantOperatorAllSelected"
                      @operatorChanged="associationAssistantOperatorChanged = true"
                      :operator-options="operatorOptions"
                      >
      </standard-table>
      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button type="button"
                  class="m-1 b-c-green"
                  :disabled="!associationAssistantOperatorChanged"
                  @click="associateOperators(associatedAssistants)"> {{ $tc('message.associate', 1) }}
        </b-button>

        <b-button type="button"
                  class="m-1"
                  @click="associationAssistantOperatorChanged = false; $refs.associateOperatorsModal.hide('button')">
          {{ $tc('message.close', 1) }}
        </b-button>
      </div>
    </b-modal>

    <b-modal ref="modalErrors" id="modalErrors" :title="`${$t('message.caution')}!`"
             size="lg"
             no-close-on-backdrop no-close-on-esc hide-header-close>
      <b-container fluid>
        <b-row>
          <b-col>
            <h6 class="text-danger">{{ $tc('errors.departureRegistration', 1) }}</h6>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <h4>{{ $t('errors.errorsList') }}:</h4>
          </b-col>
        </b-row>

        <b-row>
          <b-container>
            <b-list-group>
              <b-list-group-item v-for="(item, index) in departureErrorsAndSuccess" :key="index">
                <b-row v-if="item.errors">
                  <b-col cols="12" sm="12">
                    <div v-for="message in item.errors" :key="message">
                      <h6 class="c-red font-italic">- {{ message }} </h6>
                    </div>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </b-container>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-ok-error-message" class="m-1 b-c-green" @click="$refs.modalErrors.hide()">Ok</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import _, { isNil } from 'lodash'
import { DateTime } from 'luxon'
import { Italian } from 'flatpickr/dist/l10n/it.js'

export default {
  name: 'EditTrip',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      this.$nextTick(() => {
        if (this && this.$refs && this.$refs.mainForm) this.$refs.mainForm.validate()
        if (this && this.$refs && this.$refs.stopForm && !!this.showStopEditing) this.$refs.stopForm.validate()
      })
    })
    this.$root.$on('resize', () => this.checkWindowSize())
    this.$nextTick(() => this.checkWindowSize())
  },
  data () {
    const tripId = this.$route.params.id
    const tripType = this.$route.params.type
    const lodash = _
    const backPath = '/registry/trip'
    const timePicker = {
      wrap: true,
      enableTime: true,
      enableSeconds: false,
      noCalendar: true,
      locale: Italian
    }
    const dateConfig = {
      dateFormat: 'Y-m-d',
      mode: 'single',
      altFormat: 'D j M Y',
      altInput: true,
      locale: Italian,
      minDate: '',
      maxDate: '',
      disable: []
    }
    const session = Vue.getLocalStorage('session')
    return {
      timePicker,
      backPath,
      tripId,
      lodash,
      DateTime,
      dateConfig,
      session,
      tripType,
      isMobile: false,
      input: {
        maschera_giorni: '000000'
      },
      stop: {},
      stopData: {},
      structureOptions: [],
      originalChildOptions: [],
      childOptions: [],
      filterableChildOptions: [],
      stopOption: [],
      tripStopOption: [],
      statusOptions: [
        { text: 'Salita', value: true },
        { text: 'Discesa', value: false }
      ],
      statusFilter: null,
      childrenTripStop: [],
      operatorsTripStop: [],
      watcher: null,
      itemChanged: false,
      stopWatcher: null,
      stopChanged: false,
      showStopEditing: null,
      squeezeStopList: false,
      isDragging: false,
      showCollapse: false,
      structureFilter: null,
      enableTripSaveButtons: false,
      enableDrag: false,
      operatorsModalFields: [],
      users: [],
      originalOperatorsItems: [],
      operatorOptions: [],
      filterableAssistantOptions: [],
      originalAssociation: [],
      associationAssistantOperatorChanged: false,
      tabIndex: 0,
      departureErrorsAndSuccess: [],
      attributeOptions: [],
      attributeFilter: null,
      originalTripStopOptions: [],
      depositOptions: [],
      optionPathForRequest: '',
      assistantOptions: [],
      standardAssistants: [],
      associatedAssistants: [],
      originalAssociatedAssistants: [],
      originalOperatorsTripStop: []
    }
  },
  watch: {
    showStopEditing () {
      this.resetStopWatcher()
      this.addStopWatcher()
    }
  },
  methods: {
    // Watcher functions
    checkWindowSize () {
      const size = Vue.myGetWindowSize()
      this.isMobile = (size === 'sm' || size === 'cols' || size === 'md')
    },
    resetWatcher () {
      this.$root.$emit('activeLoader', true)
      if (this.watcher) this.watcher()
      this.itemChanged = false
    },
    addWatcher () {
      this.$root.$emit('activeLoader', false)
      this.watcher = this.$watch('input', () => {
        this.itemChanged = true
      }, { deep: true })
    },
    resetStopWatcher () {
      this.$root.$emit('activeLoader', true)
      if (this.stopWatcher) this.stopWatcher()
      this.stopChanged = false
    },
    addStopWatcher () {
      this.$root.$emit('activeLoader', false)
      this.stopWatcher = this.$watch('stop', () => {
        this.stopChanged = true
      }, { deep: true })
    },

    // Getting data
    fetchData () {
      if (isNil(this.tripType)) {
        this.tripType = Vue.getLocalStorage('tripType')
      }
      this.optionPathForRequest = this.tripType === 'SINGLE' ? 'gita' : 'periodico'
      this.resetWatcher()
      this.input = { attiva: true, maschera_giorni: '000000' }
      return this.getOptions().then(() => {
        return this.getTrip().then(() => {
          this.addWatcher()
          this.$root.$emit('activeLoader', false)
          return true
        })
      })
    },
    getOptions () {
      const axiosArray = []
      axiosArray.push(this.getStructures())
      axiosArray.push(this.getChildren())
      axiosArray.push(this.getAllStop())
      axiosArray.push(this.getUsers())
      axiosArray.push(this.getAssistants())
      if (this.tripId !== 'new') {
        axiosArray.push(this.getOperator())
      }
      axiosArray.push(this.getAllTripStop())
      axiosArray.push(this.getTripChildren())
      axiosArray.push(this.getTripOperators())
      axiosArray.push(this.getAttributes())
      axiosArray.push(this.getDeposits())
      return Vue.myAll(axiosArray)
    },
    getAttributes () {
      return Vue.myGet(this, '/attributo', 'attributi').then(attributes => {
        this.attributeOptions = _.orderBy(attributes, 'nome')
        return true
      }).catch(error => {
        Vue.manageErrors(this, error)
        return true
      })
    },
    getAssistants () {
      return Vue.myGet(this, '/bus/assistente', 'assistenti').then(assistants => {
        this.standardAssistants = _.orderBy(assistants, 'id_letterale')
        return true
      }).catch(error => {
        Vue.manageErrors(this, error)
        return true
      })
    },
    getDeposits () {
      return Vue.myGet(this, '/deposito', 'depositi').then(deposits => {
        this.depositOptions = _.orderBy(deposits, 'nome')
        return true
      }).catch(error => {
        Vue.manageErrors(this, error)
        return true
      })
    },
    getStructures () {
      return Vue.myGet(this, '/struttura', 'strutture').then(structures => {
        this.structureOptions = _.orderBy(structures, 'den_sintetica')
        return true
      }).catch(error => {
        Vue.manageErrors(this, error)
        return true
      })
    },
    getChildren () {
      return Vue.myGet(this, '/bambino', 'bambini').then(children => {
        const editedItems = []
        children.forEach(item => {
          if (!item.data_cancellazione || (item.data_cancellazione && DateTime.fromISO(item.data_cancellazione) >= DateTime.local())) {
            const structure = _.find(this.structureOptions, structure => structure.id === item.id_struttura)
            if (!isNil(structure)) item.struttura = structure.den_sintetica
            editedItems.push(item)
          }
        })
        this.originalChildOptions = editedItems
      }).catch(error => {
        Vue.manageErrors(this, error)
        return true
      })
    },
    getOperator () {
      Vue.myGet(this, '/operatore?id_ruolo=3', 'operatori').then((operators) => {
        const options = [{ value: null, text: this.$t('message.selectOption') }]

        operators.forEach((operator) => {
          options.push({
            text: operator.nome.trim() + ' ' + operator.cognome.trim(),
            value: operator.id
          })
        })
        this.operatorOptions = options
        this.originalOperatorsItems = _.cloneDeep(operators)
          Vue.myGet(this, '/bus/assistente?gita=' + this.tripId, 'assistenti').then((assistants) => {
            Vue.myGet(this, '/gita_operatore?gita=' + this.tripId, 'associazioni').then((tripOperators) => {
              assistants.forEach((assistant) => {
              assistant.id_assistente = assistant.id
              delete assistant.id
                const founded = _.find(tripOperators, item => item.id_assistente === assistant.id_assistente)
                if (!isNil(founded)) {
                assistant.selected = true
                  assistant.id_operatore = founded.id_operatore
                assistant.id_gita_operatore = founded.id
              } else {
                assistant.selected = false
                assistant.id_operatore = null
              }
            })
            this.associatedAssistants = assistants
              if (this.originalAssociatedAssistants.length === 0) {
                this.originalAssociatedAssistants = _.cloneDeep(assistants)
              }
            this.originalAssociation = tripOperators
            this.$root.$emit('activeLoader', false)
            return true
          }).catch(error => {
            Vue.manageErrors(this, error)
            return false
          })
        }).catch(error => {
          Vue.manageErrors(this, error)
          return false
        })
}).catch(error => {
        Vue.manageErrors(this, error)
        return false
      })
    },
    getAllStop () {
      return Vue.myGet(this, '/bus/fermata', 'fermate').then(stops => {
        this.stopOption = stops
        return true
      }).catch(error => {
        Vue.manageErrors(this, error)
        return true
      })
    },
    getAllTripStop () {
      if (!isNaN(this.tripId)) {
        this.showStopEditing = false
        return Vue.myGet(this, `/bus/${this.optionPathForRequest}_fermata?${this.optionPathForRequest}=${this.tripId}`, 'fermate').then(stops => {
          const editedTrips = []
          stops.forEach(trip => {
            if (!trip.removed) {
              editedTrips.push(trip)
            }
          })
          this.tripStopOption = _.orderBy(editedTrips, 'orario_inizio')
          this.originalTripStopOptions = _.cloneDeep(this.tripStopOption)
          return true
        }).catch(error => {
          Vue.manageErrors(this, error)
          return true
        })
      }
      return true
    },
    getTripChildren () {
      if (!isNaN(this.tripId)) {
        return Vue.myGet(this, `/bus/bambino_${this.optionPathForRequest}_fermata?${this.optionPathForRequest}=${this.tripId}`, 'bambini').then(items => {
          this.childrenTripStop = items
          return true
        }).catch(error => {
          Vue.manageErrors(this, error)
          return true
        })
      }
      return true
    },
    getTripOperators () {
      if (!isNaN(this.tripId)) {
        return Vue.myGet(this, `/bus/operatore_${this.optionPathForRequest}_fermata?${this.optionPathForRequest}=${this.tripId}`, 'operatori').then(items => {
          this.operatorsTripStop = items
          this.originalOperatorsTripStop = items
          return true
        }).catch(error => {
          Vue.manageErrors(this, error)
          return true
        })
      }
      return true
    },
    getTrip () {
      if (this.tripId !== 'new') {
        return Vue.myGet(this, this.tripType === 'SINGLE' ? `/bus/gita/${this.tripId}` : `/bus/percorso_periodico/${this.tripId}`, this.tripType === 'SINGLE' ? 'gite' : 'percorsi_periodici').then((trip) => {
          this.input = trip
          this.input.data = trip.data
          return true
        }).catch(error => {
          Vue.manageErrors(this, error)
          return true
        })
      } else {
        this.input = { attiva: true, maschera_giorni: '000000' }
        return new Promise(resolve => resolve())
      }
    },
    getChildFields () {
      return [
        { key: 'select', label: '' },
        { key: 'nome', label: `${this.$tc('message.name', 1)}`, sortable: true, sortDirection: 'desc' },
        { key: 'cognome', label: `${this.$tc('message.surname', 1)}`, sortable: true, sortDirection: 'desc' },
        {
          key: 'codice_fiscale',
          label: `${this.$tc('message.taxCode', 1)}`,
          sortable: true,
          sortDirection: 'desc',
          hideInTable: true
        },
        { key: 'struttura', label: `${this.$tc('message.structure', 1)}`, sortable: true, sortDirection: 'desc' }
      ]
    },
    getOperatorFields () {
      return [
        { key: 'select', label: '' },
        { key: 'id_letterale', label: `${this.$tc('message.assistantId', 1)}`, sortable: true, sortDirection: 'desc' },
        { key: 'nome', label: `${this.$tc('message.name', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'cognome', label: `${this.$tc('message.surname', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: true },
        {
          key: 'codice_fiscale',
          label: `${this.$tc('message.taxCode', 1)}`,
          sortable: true,
          sortDirection: 'desc',
          hideInTable: true
        }
      ]
    },
    getCustomFields (type) {
      const fields = [
        { key: 'up&down', label: `${this.$tc('message.status', 1)}`, position: 1 },
        { key: 'note', label: `${this.$tc('message.note', 2)} ${this.$tc('message.for', 1)} ${this.$tc('message.operator', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc' }
      ]
      return fields
    },
    getEditStopOptions (options, field) {
      const editedItem = []
      options.forEach(option => {
        if (option[field] && !_.find(editedItem, obj => obj[field] === option[field])) {
          editedItem.push(option)
        }
      })
      return _.orderBy(editedItem, field)
    },
    getChildrenForTable (structure, statusFilter) {
      let editedItems = _.cloneDeep(this.filterableChildOptions)
      if (structure) editedItems = _.filter(editedItems, obj => obj.id_struttura === structure)
      if (!isNil(this.attributeFilter)) {
        editedItems = _.filter(editedItems, obj => !_.isNil(obj.attributi) && obj.attributi.length > 0 && !_.isNil(_.find(obj.attributi, item => item.id === this.attributeFilter)))
      }
      if (!_.isNil(statusFilter)) {
        editedItems.forEach((child) => {
          if (child.selected) {
            child.salita = statusFilter
          }
        })
      }
      editedItems = editedItems.sort((a, b) => {
            if (this.$refs.childrenlist && this.$refs.childrenlist.sortDesc) {
              if (a.cognome.toLowerCase() < b.cognome.toLowerCase()) { return 1 }
              if (a.cognome.toLowerCase() > b.cognome.toLowerCase()) { return -1 }
              return 0
            } else {
              if (a.cognome.toLowerCase() < b.cognome.toLowerCase()) { return -1 }
              if (a.cognome.toLowerCase() > b.cognome.toLowerCase()) { return 1 }
              return 0
            }
          }
      )
      return editedItems
    },
    getOperatorsForTable (statusFilter) {
      const editedItems = _.cloneDeep(this.filterableAssistantOptions)

       /* editedItems = editedItems.sort((a, b) => {
            if (this.$refs.operatorlist && this.$refs.operatorlist.sortDesc) {
              if (a.cognome.toLowerCase() < b.cognome.toLowerCase()) { return 1 }
              if (a.cognome.toLowerCase() > b.cognome.toLowerCase()) { return -1 }
              return 0
            } else {
              if (a.cognome.toLowerCase() < b.cognome.toLowerCase()) { return -1 }
              if (a.cognome.toLowerCase() > b.cognome.toLowerCase()) { return 1 }
              return 0
            }
          }
      ) */

      const associatedOperators = _.filter(this.operatorFilteredOptions, item => item.selected === true)
      if (!_.isNil(statusFilter)) {
        editedItems.forEach((operator) => {
          if (operator.selected) {
            operator.salita = statusFilter
          }
        })
      }
      associatedOperators.forEach((item) => {
        const foundedAssistant = _.find(editedItems, editedItem => editedItem.id_assistente === item.id_assistente)
        if (!isNil(foundedAssistant)) {
          item = foundedAssistant
        }
      })

      this.assistantOptions = editedItems
      return editedItems
    },

    // Style functions
    checkSelectStyle (ref, groupChanged, valid, errors, required, value, maxLength) {
      if (this.$refs[ref] && !this.$refs[ref].otherCheck) {
        Vue.MySelectValidationClass(this, ref, groupChanged, valid, errors, required, value, maxLength)
        this.checkCustomErrors(ref, value, maxLength)
      }
    },
    checkCustomErrors (ref, value, maxLength) {
      this.$refs[ref].otherCheck = true
      if (value && maxLength && `${value}`.length > maxLength) {
        const invalidClass = 'vs__dropdown-toggle form-control is-invalid'
        const message = `${this.$tc('errors.genericMaxLength1', 1)} ${maxLength} ${this.$tc('errors.genericMaxLength2', 1)}`
        const select = this.$refs[ref] && this.$refs[ref].$el && this.$refs[ref].$el.children && _.first(this.$refs[ref].$el.children)
        if (this.$refs[`${ref}-validator`]) {
          this.$refs[`${ref}-validator`].setErrors([message])
          select.className = invalidClass
        }
      }
      this.$nextTick(() => { this.$refs[ref].otherCheck = false })
    },

    // Trip functions
    checkTripSave (invalid, pending, dataNotChanged, showStopEditing) {
      this.enableTripSaveButtons = invalid || pending || dataNotChanged || showStopEditing
    },
    save (pushBack, skipNotice) {
      const editedItem = _.cloneDeep(this.input)
      editedItem.forza_nfc = false
      Vue.patchOrPost(this.tripId !== 'new',
          `/bus/${this.tripType === 'PERIODIC' ? 'percorso_periodico' : 'gita'}${this.tripId !== 'new' ? '/' + this.tripId : ''}`, editedItem).then(r => {
        if (!skipNotice) Vue.success(this, `${this.$tc('message.trip', 1)} ${this.$t(this.tripId !== 'new' ? 'success.putSuccess' : 'success.postSuccess')}`)
        Vue.setLocalStorage('tripType', this.tripType)
        if (pushBack) this.$router.push(this.backPath)
        else this.$router.push({ name: 'RefreshPage', params: { id: this.input.id || r.data.id, name: 'EditTrip' } })
      }).catch(errorObj => {
        Vue.manageErrors(this, errorObj)
      })
    },
    saveStop () {
      const stopObj = this.parseStopObj(_.cloneDeep(this.stop))
      const alreadyExist = _.find(this.stopOption, obj => {
        let isEqual = true
        _.forOwn(stopObj, (val, field) => {
          if (isEqual) isEqual = val === obj[field]
        })
        return isEqual ? obj : null
      })
      const stopData = _.cloneDeep(this.stopData)
      const childrenTripStop = this.$refs.childrenlist ? _.cloneDeep(this.$refs.childrenlist.componentItems) : _.cloneDeep(this.childOptions)
      const operatorsTripStop = this.$refs.operatorslist ? _.cloneDeep(this.$refs.operatorslist.componentItems) : _.cloneDeep(this.operatorFilteredOptions)
      if (alreadyExist || (stopData && stopData.fermata && stopData.fermata.id)) {
        if (!alreadyExist) {
          Vue.patchOrPost(!!stopData.fermata.id, `/bus/fermata/${stopData.fermata.id}`, stopObj).then(() => {
            this.saveTripStop(stopData, childrenTripStop, operatorsTripStop).then(() => {
              this.fetchData()
            }).catch(error => {
              Vue.manageErrors(this, error)
              return false
            })
          }).catch(error => {
            Vue.manageErrors(this, error)
            return false
          })
        } else {
          stopData.id_fermata = alreadyExist.id
          this.saveTripStop(stopData, childrenTripStop, operatorsTripStop).then(() => {
            this.fetchData()
          }).catch(error => {
            Vue.manageErrors(this, error)
            return false
          })
        }
      } else {
        Vue.patchOrPost(false, '/bus/fermata', stopObj).then(stop => {
          const tripStop = { id_fermata: stop.data.id, orario_inizio: stopData.orario_inizio, orario_fine: stopData.orario_fine }
          if (this.tripType === 'PERIODIC') {
            tripStop.id_periodico = parseInt(this.tripId)
          } else {
            tripStop.id_gita = parseInt(this.tripId)
          }
          this.saveTripStop(tripStop, childrenTripStop, operatorsTripStop).then(() => {
            this.fetchData()
          }).catch(error => {
            Vue.manageErrors(this, error)
            return false
          })
        }).catch(error => {
          Vue.manageErrors(this, error)
          return false
        })
      }
    },
    exitCheck (itemChanged) {
      if (itemChanged) this.$root.$emit('exit-check', { redirect: this.backPath })
      else this.$router.push(this.backPath)
    },

    // Trip-stop functions
    saveTripStop (item, childrenTripStop, operatorsTripStop) {
      return Vue.patchOrPost(!!item.id, `/bus/${this.optionPathForRequest}_fermata${item.id ? '/' + item.id : ''}`, item).then(tripStop => {
        if (childrenTripStop && childrenTripStop.length !== 0) {
          const axiosArray = []
          const editedItem = {}
          if (this.tripType === 'SINGLE') {
            editedItem.id_gita_fermata = item.id || tripStop.data.id
          } else {
            editedItem.id_periodico_fermata = item.id || tripStop.data.id
          }
          let path = `bambino_${this.optionPathForRequest}_fermata`
          childrenTripStop.forEach(child => {
            const editedItemChild = editedItem
            editedItemChild.id = child.tripChildId || null
            editedItemChild.id_bambino = child.id
            editedItemChild.note = child.note
            editedItemChild.salita = child.salita
            const originalItem = !_.isNil(editedItemChild.id) ? _.find(this.childrenTripStop, obj => obj.id === child.tripChildId) : null
            if (child.selected && ((!_.isNil(originalItem) && originalItem.salita !== child.salita) || _.isNil(originalItem) || (!_.isNil(originalItem) && originalItem.note !== child.note))) {
              axiosArray.push(this.updateChildOrOperatorTrip(editedItemChild, child, path))
            } else if (child.tripChildId && !child.selected) {
              axiosArray.push(this.deleteChildOrOperatorTrip(editedItemChild, path))
            }
          })
          path = `operatore_${this.optionPathForRequest}_fermata`
          operatorsTripStop.forEach(operator => {
            editedItem.id = operator.tripOperatorId || null
            editedItem.id_assistente = operator.id
            editedItem.salita = operator.salita
            const originalItem = !_.isNil(editedItem.id) ? _.find(this.operatorsTripStop, obj => obj.id === operator.tripOperatorId) : null
            if (operator.selected && ((!_.isNil(originalItem) && originalItem.salita !== operator.salita) || _.isNil(originalItem))) {
              axiosArray.push(this.updateChildOrOperatorTrip(editedItem, operator, 'operatore_' + this.optionPathForRequest + '_fermata'))
            } else if (operator.tripOperatorId && !operator.selected) {
              axiosArray.push(this.deleteChildOrOperatorTrip(editedItem, 'operatore_' + +this.optionPathForRequest + '_fermata'))
            }
          })

          return Vue.myAll(axiosArray).then((results) => {
            const errorsChildren = []
            results.forEach((result) => {
              const object = {}
              if (!_.isNil(result) && !_.isNil(result.errors) && result.errors.length > 0) {
                object.errors = result.errors
                errorsChildren.push(object)
              }
            })

            if (errorsChildren.length > 0) {
              this.openModalError(errorsChildren)
              Vue.success(this, `${this.$tc('message.trip', 1)} ${this.$t(this.tripId !== 'new' ? 'success.putSuccess' : 'success.postSuccess')}`)
            } else {
              Vue.success(this, `${this.$tc('message.trip', 1)} ${this.$t(this.tripId !== 'new' ? 'success.putSuccess' : 'success.postSuccess')}`)
              this.fetchData()
              return true
            }
          }).catch(error => {
            Vue.manageErrors(this, error)
            return true
          })
        } else {
          return true
        }
      }).catch(error => { throw error })
    },
    openModalError (errors) {
      this.departureErrorsAndSuccess = errors
      this.$refs.modalErrors.show()
    },
    parseStopObj (obj) {
      return {
        nome: obj.nome || null,
        descrizione: obj.descrizione || null,
        indirizzo: obj.indirizzo || null,
        civico: obj.civico || null,
        struttura: obj.struttura || null
      }
    },
    updateTripStopIdx (item, newIndex) {
      item.draggableIndex = newIndex + 1
    },
    handleDragStop (event) {
      this.enableDrag = false
      this.isDragging = false
      this.$root.$emit('activeLoader', true)
      const items = _.cloneDeep(this.tripStopOption)
      const foundedItem = _.find(items, obj => obj.draggableIndex === event.newIndex + 1)
      const copy = _.cloneDeep(foundedItem)
      const secondFoundedItem = this.originalTripStopOptions[event.newIndex]
      copy.id_fermata = secondFoundedItem.id_fermata
      return Vue.patchOrPost(!!copy.id, `/bus/${this.optionPathForRequest}_fermata${foundedItem.id ? '/' + foundedItem.id : ''}`, copy).then(() => {
        secondFoundedItem.id_fermata = foundedItem.id_fermata
        return Vue.patchOrPost(!!copy.id, `/bus/${this.optionPathForRequest}_fermata${secondFoundedItem.id ? '/' + secondFoundedItem.id : ''}`, secondFoundedItem).then(() => {
          Vue.success(this, `${this.$tc('message.trip', 1)} ${this.$t(this.tripId !== 'new' ? 'success.putSuccess' : 'success.postSuccess')}`)
          this.fetchData()
          this.$root.$emit('activeLoader', false)
        }).catch(error => {
          Vue.manageErrors(this, error)
          this.$root.$emit('activeLoader', false)
        })
      }).catch(error => {
        Vue.manageErrors(this, error)
        this.$root.$emit('activeLoader', false)
      })
    },
    hideDeleteModal () {
      this.$refs.deleteModal.hide()
      this.childOptions = []
      this.filterableChildOptions = []
      this.stopData = {}
      if (this.tripType === 'PERIODIC') {
        this.stopData.id_periodico = parseInt(this.tripId)
      } else {
        this.stopData.id_gita = parseInt(this.tripId)
      }
    },
    deleteItem () {
      const axiosArray = []
      const items = _.cloneDeep(this.tripStopOption)
      const itemToDelete = this.stopData
      const childrenToDelete = _.filter(this.childOptions, obj => obj.selected)

      this.$root.$emit('activeLoader', true)
      childrenToDelete.forEach(item => {
        const editedItem = { id: item.tripChildId }
        axiosArray.push(this.deleteChildTrip(editedItem))
      })

      Vue.myAll(axiosArray).then(() => {
        this.deleteTripStop(itemToDelete).then(() => {
          itemToDelete.draggableIndex = items.length + 1
            this.fetchData().then(() => {
              this.$root.$emit('activeLoader', false)
              Vue.success(this, `${this.$tc('message.delete')} ${this.$tc('message.done', 2).toLowerCase()}`)
              this.hideDeleteModal()
          })
        })
      })
    },
    deleteTripStop (item) {
      return Vue.myDelete(`/bus/${this.optionPathForRequest}_fermata/${item.id}`).then(r => r).catch(error => {
        Vue.manageErrors(this, error)
        return true
      })
    },

    // Trip-stop-child functions
    showStopEditingSide (item, type) {
      this.statusFilter = null
      this.enableDrag = false
      this.tripStopOption.forEach((element) => {
        element.class = ''
      })
      if (!isNil(item)) item.class = 'b-g-selected'
      this.resetStopWatcher()
      if (this.$refs.stopForm) this.$refs.stopForm.reset()
      if (item && item.fermata) this.stop = _.cloneDeep(item.fermata)
      else this.stop = {}
      this.checkAvailableChildren(item)
      this.checkAvailableOperators(item)
      this.addStopWatcher()
      this.showStopEditing = type
      if (isNil(type)) this.$refs.deleteModal.show()
    },
    openInfoModal (item) {
      if (item && item.fermata) this.stop = _.cloneDeep(item.fermata)
      this.$refs.infoModal.show()
    },
    checkAvailableChildren (item) {
      const allTripStop = _.cloneDeep(this.tripStopOption)
      const originalChildrenTripStop = _.cloneDeep(this.childrenTripStop)
      const originalChildOptions = _.cloneDeep(this.originalChildOptions)
      let remainingChildOption = _.cloneDeep(this.originalChildOptions)
      const allChildrenTripStop = !_.isNil(item) && !_.isNil(item.id) ? _.filter(originalChildrenTripStop, childStop => !isNil(childStop.id_gita_fermata) ? childStop.id_gita_fermata === item.id : childStop.id_periodico_fermata === item.id) : []
      const tripStop = !_.isNil(item) && !_.isNil(item.id) ? _.filter(allTripStop, childStop => childStop.id === item.id) : []
      const editedTripStop = tripStop
      editedTripStop.children = []
      if (allChildrenTripStop && allChildrenTripStop.length !== 0) {
        allChildrenTripStop.forEach(childTripStop => {
          const foundedChild = _.find(originalChildOptions, obj => obj.id === childTripStop.id_bambino)
          if (foundedChild) {
            const editedChild = foundedChild
            editedChild.tripChildId = childTripStop.id
            editedChild.selected = true
            editedChild.note = childTripStop.note
            editedChild.salita = childTripStop.salita
            editedTripStop.children.push(editedChild)
            remainingChildOption = _.remove(remainingChildOption, obj => obj.id !== editedChild.id)
          }
        })
      }

      if (editedTripStop && editedTripStop.children && editedTripStop.children.length !== 0) {
        editedTripStop.children.forEach(child => {
          remainingChildOption.push(child)
        })
      }
      this.childOptions = _.orderBy(remainingChildOption, 'nome')
      this.filterableChildOptions = _.cloneDeep(this.childOptions)

      this.stopData = item || {}
      if (this.tripType === 'PERIODIC') {
        this.stopData.id_periodico = parseInt(this.tripId)
      } else {
        this.stopData.id_gita = parseInt(this.tripId)
      }
    },

    checkAvailableOperators (item) {
      const originalOperatorsTripStop = _.cloneDeep(this.operatorsTripStop)
      const allOperatorsTripStop = !_.isNil(item) && !_.isNil(item.id) ? _.filter(originalOperatorsTripStop, operatorStop => !isNil(operatorStop.id_gita_fermata) ? operatorStop.id_gita_fermata === item.id : operatorStop.id_periodico_fermata === item.id) : []
      const standardAssistants = this.standardAssistants
      standardAssistants.forEach((item) => {
        item.selected = false
      })
      if (allOperatorsTripStop && allOperatorsTripStop.length !== 0) {
        allOperatorsTripStop.forEach(operatorTripStop => {
            const editedOperator = _.find(standardAssistants, obj => obj.id === operatorTripStop.id_assistente)
          editedOperator.tripOperatorId = operatorTripStop.id
            editedOperator.selected = true
            editedOperator.salita = operatorTripStop.salita
            const foundAssociation = _.find(this.originalAssociation, association => association.id_assistente === operatorTripStop.id_assistente)
            if (!isNil(foundAssociation) && !isNil(foundAssociation.operatore)) {
                editedOperator.nome = foundAssociation.operatore.nome
                editedOperator.cognome = foundAssociation.operatore.cognome
            }
        })
      }
      this.operatorFilteredOptions = _.orderBy(standardAssistants, 'id_letterale')
      this.filterableAssistantOptions = this.operatorFilteredOptions
      this.stopData = item || {}
      if (this.tripType === 'PERIODIC') {
        this.stopData.id_periodico = parseInt(this.tripId)
      } else {
        this.stopData.id_gita = parseInt(this.tripId)
      }
    },
    hideStopEditingSide () {
      this.showStopEditing = false
    },
    resetFilters () {
      this.$refs.childrenlist.resetSearch()
      this.$refs.operatorslist.resetSearch()
    },
    deleteChildOrOperatorTrip (item, path) {
      return Vue.myDelete(`/bus/${path}/${item.id}`).then(r => r).catch(error => {
        Vue.manageErrors(this, error)
        return true
      })
    },
    updateChildOrOperatorTrip (item, person, path) {
      if (!item.id) delete item.id
      const errors = []
      return Vue.patchOrPost(!!item.id, item.id ? `/bus/${path}/${item.id}` : '/bus/' + path, item).then(r => {
        return { errors }
      }).catch(error => {
        if (!_.isNil(error) && !_.isNil(error.response) && !_.isNil(error.response.data) &&
            !_.isNil(error.response.data.code) && error.response.data.code === 9) {
          let errorMessage = this.$t('errors.departureNotValid')
          if (!isNil(person.id_letterale)) errorMessage += ' ' + person.id_letterale
          if (!isNil(person.nome)) errorMessage += ' ' + person.nome
          if (!isNil(person.cognome)) errorMessage += ' ' + person.cognome
          if (person.salita) {
            errorMessage += ' (' + this.$t('message.up') + ')'
          } else {
            errorMessage += ' (' + this.$t('message.down') + ')'
          }
          errors.push(errorMessage)
          return { errors }
        } else {
          Vue.manageErrors(this, error)
          return { errors }
        }
      })
    },
    handleAllSelected (items) {
      this.stopChanged = true
      items.forEach(item => {
        item.selected = !item.selected
        this.handleTableSelection(item)
      })
    },
    handleUpAndDown (item, val) {
      if (this.tabIndex === 0) {
        const clonedIndex = _.findIndex(this.childOptions, obj => obj.id === item.id)
        const originalIndex = _.findIndex(this.childOptions, obj => obj.id === item.id)
        this.childOptions[originalIndex].salita = val
        this.filterableChildOptions[clonedIndex].salita = val
      } else {
        const originalIndex = _.findIndex(this.assistantOptions, obj => obj.id === item.id)
        this.assistantOptions[originalIndex].salita = val
        this.filterableAssistantOptions[originalIndex].salita = val
      }
      this.stopChanged = true
      item.salita = val
    },
    handleTableSelection (item) {
      this.stopChanged = true
      if (this.tabIndex === 0) {
        const originalIndex = _.findIndex(this.childOptions, obj => obj.id === item.id)
        const clonedIndex = _.findIndex(this.childOptions, obj => obj.id === item.id)
        this.childOptions[originalIndex].selected = item.selected
        this.filterableChildOptions[clonedIndex].selected = item.selected
      } else {
        const originalIndex = _.findIndex(this.assistantOptions, obj => obj.id === item.id)
        if (!_.isNil(originalIndex)) {
          this.assistantOptions[originalIndex].selected = item.selected
         this.filterableAssistantOptions[originalIndex].selected = item.selected
        }
      }
    },
    showExportModal () {
      if (this.$refs && this.$refs.associateOperatorModal) this.$refs.associateOperatorModal.show()
    },

    getFields () {
      return [
        { key: 'select', label: '' },
        {
          key: 'id_letterale',
          label: `${this.$tc('message.assistantId', 1)}`,
          sortable: true,
          sortDirection: 'desc'
        },
        { key: 'operator_selector', label: `${this.$tc('message.operator', 1)}` }
      ]
    },
    getUsers () {
      this.users = []
      return Vue.myGet(this, '/utente?all=true', 'utenti').then(users => {
        this.users = users
        return true
      }).catch(error => {
        Vue.manageErrors(this, error)
        return true
      })
    },
    checkAssociateModalClosing (event) {
      if (event.trigger !== 'button') {
        event.preventDefault()
        this.associatedAssistants = []
      }
    },
    handleAssociationAssistantOperatorAllSelected (event) {
      this.associationAssistantOperatorChanged = true
      const changedItems = Array.isArray(event) ? event : [event]
      changedItems.forEach(item => {
        item.selected = !item.selected
      })
    },
    handleAssociationAssistantOperatorRowSelected (item) {
      this.associationAssistantOperatorChanged = true
      const originalIndex = _.findIndex(this.originalAssociatedAssistants, obj => obj.id_assistente === item.id_assistente)
      this.associatedAssistants[originalIndex].selected = item.selected
      if (!item.selected) this.associatedAssistants[originalIndex].id_operatore = null
    },
    showAssociateOperatorModal () {
      this.enableDrag = false
      this.isDragging = false
      this.showStopEditing = false
      if (this.$refs && this.$refs.associateOperatorsModal) this.$refs.associateOperatorsModal.show()
    },
    associateOperators (items) {
      const toAdd = []
      this.$root.$emit('activeLoader', true)
      items.forEach(item => {
        const foundInOriginals = _.find(this.originalAssociatedAssistants, originalItem => item.id_gita_operatore === originalItem.id_gita_operatore)
        if (item.selected && _.isNil(item.id_gita_operatore)) {
          toAdd.push({
            id_operatore: item.id_operatore,
            id_gita: this.tripId,
            id_assistente: item.id_assistente
          })
        } else if (!_.isNil(item.id_gita_operatore) && !item.selected) {
          Vue.myDelete(`/gita_operatore/${item.id_gita_operatore}`).then(r => r).catch(error => {
            Vue.manageErrors(this, error)
            return true
          })
        } else if (!_.isNil(foundInOriginals) && item.selected && foundInOriginals.id_operatore !== item.id_operatore) {
          Vue.patchOrPost(true, `/gita_operatore/${foundInOriginals.id_gita_operatore}`, { id_operatore: item.id_operatore, id_gita: this.tripId, id_assistente: item.id_assistente }).then(r => {
                Vue.success(this, `${this.$tc('message.associate', 2)} ${this.$t('success.putSuccess')}`)
                this.getOperator()
                this.$refs.associateOperatorsModal.hide('button')
            Vue.setLocalStorage('tripType', this.tripType)
            this.$root.$emit('activeLoader', false)
            this.$router.push({ name: 'RefreshPage', params: { id: this.input.id || r.data.id, name: 'EditTrip' } })
            return true
          }).catch(error => {
            this.$root.$emit('activeLoader', false)
            Vue.manageErrors(this, error)
            return false
          })
        }
      })
      if (toAdd.length > 0) {
        Vue.patchOrPost(null, '/gita_operatore', toAdd).then(r => {
          Vue.success(this, `${this.$tc('message.associate', 2)} ${this.$t('success.postSuccess')}`)
          this.getOperator()
          this.$refs.associateOperatorsModal.hide('button')
          Vue.setLocalStorage('tripType', this.tripType)

          this.$router.push({ name: 'RefreshPage', params: { id: this.input.id || r.data.id, name: 'EditTrip' } })
        }).catch(error => {
          Vue.manageErrors(this, error)
        })
      }
    },
    getFlatPickrClass (ref, valid, errors, itemChanged, isRequired) {
      const nullClass = 'form-control'
      const falseClass = 'form-control is-invalid'
      const trueClass = 'form-control is-valid'
      const result = isRequired
          ? _.first(errors) && itemChanged ? falseClass : (valid ? (itemChanged ? trueClass : nullClass) : nullClass)
          : _.first(errors) ? falseClass : nullClass

      if (this.$refs && this.$refs[ref] && this.$refs[ref].$el && this.$refs[ref].$el.parentElement) {
        const el = this.$refs[ref].$el.parentElement.children && this.$refs[ref].$el.parentElement.children[1]
        el.className = result
      }

      return result
    },
    deleteChildTrip (item) {
      return Vue.myDelete(`/bus/bambino_${this.optionPathForRequest}_fermata/${item.id}`).then(r => r).catch(error => {
        Vue.manageErrors(this, error)
        return true
      })
    },
    setCharAt (str, index, chr) {
      if (index > str.length - 1) return str
      return str.substring(0, index) + chr + str.substring(index + 1)
    }
  }
}
</script>

<style scoped>
.stop-details-row {
  display: grid;
  flex-direction: row;
  flex-wrap: wrap;
  height: 100%;
}

.stop-details-col {
  min-width: 100%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

.stop-details-text {
  flex-grow: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0;
  align-self: center;
  margin-left: 0.1em;
}

.b-g-selected{
  background-color: #abe2e2;
}

.my-icon {
  height: calc(35px + 6 * ((100vw - 150px) / 8000)) !important;
  width: calc(35px + 6 * ((100vw - 150px) / 8000)) !important;
}

.my-icon-small {
  height: calc(25px + 6 * ((100vw - 150px) / 8000)) !important;
  width: calc(25px + 6 * ((100vw - 150px) / 8000)) !important;
}
</style>
